import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import { ProductCardVariants } from './NewProductCard';
import { theme } from '~/theme';

type Props = IContentLoaderProps & {
    variant?: ProductCardVariants;
    isFavorite?: boolean;
};

/**
 * @deprecated Modelled on the old `ProductCard`. Prefer `NewProductCardSkeleton` instead
 * which is built from the card's own styles. This is kept because it's used in `P80FavouritesPage`.
 */
export const NewProductCardLoader: React.FC<Props> = ({ isFavorite, variant, ...rest }) => {
    const isOpaque = variant === 'opaque';
    const x = isOpaque ? 16 : 0;

    return (
        <ContentLoader
            speed={1}
            width="100%"
            height="596"
            viewBox="0 0 276 596"
            backgroundColor="#f5f5f5"
            foregroundColor="#dbdbdb"
            style={{ backgroundColor: isOpaque ? theme.colors.white : undefined }}
            {...rest}
        >
            <rect x="0" y="0" rx="0" ry="0" width="100%" height={isFavorite ? '421' : '276'} />
            <rect x={x} y="288" rx="0" ry="0" width="140" height="21" />
            <rect x={x} y="313" rx="0" ry="0" width="175" height="20" />
            <rect x={x} y="349" rx="0" ry="0" width="75%" height="18" />
            <rect x={x} y="371" rx="0" ry="0" width="130" height="18" />
            <rect x={x} y="450" rx="0" ry="0" width="100" height="20" />
            <rect x={x} y="480" rx="0" ry="0" width="120" height="20" />
            <rect x={x} y="510" rx="0" ry="0" width="100" height="20" />
            <rect
                x={x}
                y="540"
                rx="6"
                ry="6"
                width={isOpaque ? 'calc(100% - 32px)' : '100%'}
                height="48"
            />
        </ContentLoader>
    );
};
